module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Edit-8eb1b429a14273912025b1f575e28765.svg";